import React, { useEffect, useRef, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Box, Card, CardContent, CardMedia, Rating, Stack, Typography, Button } from "@mui/material";
import Grid from '@mui/material/GridLegacy';
import { motion } from "framer-motion";
import AnimatedText from "../component/animatedtext";
import pratham from '../assets/image/pratham.jpg'
import dev from '../assets/image/dev.jpg';
import kenny from '../assets/image/kenny.jpg';
import CustomProgress, { CustomAccordion } from "../utils";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import Accordion, { accordionClasses } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails, {
    accordionDetailsClasses,
} from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fade from '@mui/material/Fade';
import StarIcon from "@mui/icons-material/Star";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WorkIcon from "@mui/icons-material/Work";
import SchoolIcon from "@mui/icons-material/School";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import img1 from '../assets/image/66419cd8af838_1715576024.jpg';
import img2 from '../assets/image/66419d7a0c0ea_1715576186.jpg';
import img3 from '../assets/image/6641b354585d1_1715581780.jpg';
import img4 from '../assets/image/6641b5509d662_1715582288.jpg';
import img5 from '../assets/image/6641b67927faf_1715582585.jpg';
import img6 from '../assets/image/6641b95b1e5fa_1715583323.jpeg';
import img7 from '../assets/image/6663ece096808_1717824736.jpeg';
import img8 from '../assets/image/6663feff934db_1717829375.jpeg';
import img9 from '../assets/image/66640cc17683c_1717832897.jpg';
import img10 from '../assets/image/66643f4a53bf6_1717845834.jpeg';
import img11 from '../assets/image/66644b8718c10_1717848967.jpg';
import img12 from '../assets/image/66644a5d81cf1_1717848669.jpeg';
import home1 from '../assets/image/home1.png';
import home2 from '../assets/image/home2.png';
import home3 from '../assets/image/home3.png';
import home5 from '../assets/image/home5.png';
import topsec from '../assets/image/topdimondsec.jpg'
import burning from '../assets/image/burning.png';
import homeback from '../assets/image/homeback.png'
import whynow from '../assets/image/whynow.png'
import hometop from '../assets/image/homelatest.jpg';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "../pages/index.css"
import RightSwipeableDrawer from '../component/drawer';
import { useNavigate } from "react-router-dom";
import { CheckCircle, School, EditNote, Gavel, MonetizationOn, Work, Diversity3, Flag } from "@mui/icons-material";

const highlights = [
    "100+ verified mentors currently active",
    "Covering countries like the US, UK, Canada, Australia, Germany, and more",
    "Affordable, practical, and personalized guidance",
];

const domains = [
    { icon: <School />, title: "University & Course Selection" },
    { icon: <EditNote />, title: "SOP & Application Review" },
    { icon: <Gavel />, title: "Visa & Immigration Guidance" },
    { icon: <MonetizationOn />, title: "Scholarship & Financial Planning" },
    { icon: <Work />, title: "Part-Time Jobs & Internships" },
    { icon: <Diversity3 />, title: "Cultural Adjustment & Networking" },
    //   { icon: <Home />, title: "Accommodation Assistance" },
    { icon: <Flag />, title: "Career Planning Post-Graduation" },
];
const colors = ["#9ECAE1", "#DEEBF7", "#3182BD", "#9ECAE1", "#DEEBF7", "#3182BD", "#9ECAE1"];
const Home = () => {
    const [expanded, setExpanded] = React.useState(false);
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [selectedItem, setSelectedItem] = React.useState(null);
    const scrollRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once
        });
        let scrollSpeed = 80; // Adjust speed (Higher = Slower)

        const startScroll = () => {
            const interval = setInterval(() => {
                if (!isPaused) {
                    scrollContainer.scrollTop += 1;
                    if (scrollContainer.scrollTop >= scrollContainer.scrollHeight - scrollContainer.clientHeight) {
                        scrollContainer.scrollTop = 0; // Reset for infinite loop
                    }
                }
            }, scrollSpeed);

            return () => clearInterval(interval);
        };

        const stopScroll = startScroll();

        const handleMouseEnter = () => setIsPaused(true);
        const handleMouseLeave = () => setIsPaused(false);

        scrollContainer.addEventListener("mouseenter", handleMouseEnter);
        scrollContainer.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            clearInterval(stopScroll);
            scrollContainer.removeEventListener("mouseenter", handleMouseEnter);
            scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, [isPaused]);

    const handleOpenDrawer = (item) => {

        setSelectedItem(item);  // Store clicked card data
        setOpenDrawer(true);    // Open the drawer
    };

    const phrases = [
        "Study Abroad with Confidence ",
        "Mentored by Those with Experience",
    ];
    const studentfeed = [
        {
            name: "Ritika Sharma",
            rate: '5',
            image: kenny,
            feed: "Priya helped me avoid the mistakes I was about to make in my SOP. I now have a better shot at my dream university!"
        },
        {
            name: "Mohit Raj ",
            rate: '3',
            image: dev,
            feed: "I was overwhelmed by the visa process. Aakash explained each step like a friend. Highly recommend!"
        }
    ]
    const MentosData = [
        {
            color: "DEEBF7",
            name: "Priya Mehta",
            rate: '5',
            image: pratham,
            Desc: "I struggled with my visa process and wish I had someone to guide me. Now, I’m here to make things easier for you",
            exp: "University of Toronto, Canada"
        },
        {
            color: "9ECAE1",
            name: "Aakash Patel ",
            rate: '3',
            image: dev,
            Desc: "I know how confusing the application process is, so let me help you figure it out step by step",
            exp: "London School of Economics, UK"
        },
        {
            color: "DEEBF7",
            name: "Elena Rodriguez",
            rate: '4',
            image: kenny,
            Desc: "Finding affordable accommodation, cultural adjustment.",
            exp: "University of Sydney, Australia"
        },
        {
            color: "9ECAE1",
            name: "Mrun",
            rate: '2',
            image: pratham,
            Desc: "Your mentorship has been incredibly valuable to me, and I truly appreciate the time and effort you’ve invested .",
            exp: "abcs Year"
        },
    ]
    const images = [
        img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12
    ]
    const categories = [
        { text: "University and Course Selection ", icon: <WorkIcon /> },
        { text: "Application and SOP Review ", icon: <BusinessIcon /> },
        { text: "Visa and Immigration Help ", icon: <SchoolIcon />, highlight: true },
        { text: "Career Planning ", icon: <SchoolIcon /> },
    ];
    // const cardsData = [
    //     {
    //         bg: "#9ECAE1",
    //         title: "",
    //         subtitle: "Mentors",
    //         content: null,
    //     },
    //     {
    //         bg: " #DEEBF7",
    //         title: "500+",
    //         subtitle: "Mentorship Mins",
    //         content: <Rating name="read-only" value={5} readOnly />,
    //         icon: <HistoryToggleOffIcon sx={{ color: "white", fontSize: 100 }} />,
    //     },
    //     {
    //         bg: "#3182BD",
    //         title: "10+",
    //         subtitle: "Domains",
    //         content: (
    //             <Stack spacing={1} mt={2} sx={{ alignItems: "end" }}>
    //                 {categories.map((item, index) => (
    //                     <Box
    //                         key={index}
    //                         sx={{
    //                             display: "flex",
    //                             alignItems: "center",
    //                             gap: 1,
    //                             background: item.highlight ? "#FFCA28" : "#FFF",
    //                             // padding: "6px 12px",
    //                             borderRadius: 3,
    //                             boxShadow: item.highlight ? 2 : 0,
    //                             // cursor: "pointer",
    //                         }}
    //                     >
    //                         <Avatar
    //                             sx={{
    //                                 bgcolor: item.highlight ? "#FBC02D" : "#FFF",
    //                                 color: item.highlight ? "#000" : "#6D6D6D",
    //                             }}
    //                         >
    //                             {item.icon}
    //                         </Avatar>
    //                         <Typography fontWeight={item.highlight ? "bold" : "normal"}>
    //                             {item.text}
    //                         </Typography>
    //                     </Box>
    //                 ))}
    //             </Stack>
    //         ),
    //     },
    // ];
    const mentorData = {
        name: "Denis Čahuk",
        title: "Productive Tech Leadership...",
        image: "https://via.placeholder.com/50", // Replace with actual image
        pricing: "$80/month",
        sessions: ["Mentorship", "Intro Session", "CV Review", "Expert Session"],
    };
    const cardsData = [
        {
            title: "99+",
            subtitle: "Mentors",
            content: null,
            backContent: "Expert Mentorship for Lifelong Learning and Limitless Growth!",
            bg: "#9ECAE1",
        },
        {
            title: "500+",
            subtitle: "Mentorship Mins",
            content: <Rating name="read-only" value={5} readOnly />,
            backContent: "Unlock Your Potential with Expert Mentorship and Lifelong Growth!",
            bg: "#DEEBF7",
        },
        {
            title: "10+",
            subtitle: "Domains",
            content: null,
            backContent: "Expert Mentorship Across Multiple Domains for Limitless Growth!",
            bg: "#3182BD",
        },
    ];
    const benefits = [
        "Thousands of mentors available",
        "Free trial",
        "1-on-1 calls",
        "Flexible program structures",
        "Personal chats",
        "96% satisfaction rate",
    ];
    const FlipCard = ({ card }) => {
        const [isFlipped, setIsFlipped] = useState(false);
        const [count, setCount] = useState(0);
        useEffect(() => {
            let targetValue = parseInt(card.title.replace(/\D/g, ""), 10); // Extract numbers
            let increment = Math.ceil(targetValue / 50); // Adjust speed

            let interval = setInterval(() => {
                setCount((prev) => {
                    if (prev >= targetValue) {
                        clearInterval(interval);
                        return targetValue;
                    }
                    return prev + increment;
                });
            }, 100); // Adjust speed here

            return () => clearInterval(interval);
        }, [card.title]);

        return (
            <Box
                sx={{
                    perspective: "1000px",
                    width: "250px",
                    height: "150px",
                    position: "relative",
                    margin: "0 15px", // Space between cards
                }}
                onMouseEnter={() => setIsFlipped(true)} // Flip on hover
                onMouseLeave={() => setIsFlipped(false)} // Reset on leave
            >
                <Box
                    sx={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        transformStyle: "preserve-3d",
                        transition: "transform 0.6s",
                        transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)", // Flip effect
                    }}
                >
                    {/* Front Side */}
                    <Box
                        sx={{
                            backgroundColor: card.bg,
                            borderRadius: "10px",
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            backfaceVisibility: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            // padding: "16px",
                        }}
                    >
                        <Typography variant="h4" color="black">
                            {count}+
                        </Typography>
                        <Typography variant="h6" color={card.bg === "blue" ? "white" : "black"}>
                            {card.subtitle}
                        </Typography>
                        <Typography color={card.bg === "blue" ? "white" : "black"}>
                            {card.content}
                        </Typography>
                    </Box>

                    {/* Back Side */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            backfaceVisibility: "hidden",
                            backgroundColor: "white",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "10px",
                            backgroundColor: "aliceblue",
                            transform: "rotateY(180deg)", // Flip back properly
                        }}
                    >
                        <Typography variant="h6" color="black">
                            {card.backContent}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        );
    };
    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    height: { xs: "34vh", sm: "65vh", md: "100vh", lg: "100vh", xl: "100vh" },
                    overflow: "hidden",
                    backgroundImage: `url(${hometop})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <motion.div
                    initial={{ y: "-100vh", opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 1.8, ease: "easeOut" }}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "left",
                        width: "100%",
                        height: "100%",
                        fontFamily: `"Poppins", sans-serif !important`,
                        textAlign: "left",
                        paddingLeft: "10px"
                    }}
                >
                    <Typography
                        variant="h1"
                        sx={{
                            background: 'linear-gradient(to right, #0f9ba1, #8ee3a8)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            fontWeight: 'bold',
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: {
                                xs: '1.3rem',
                                sm: '2.8rem',
                                md: '3rem',
                                lg: '4rem',
                                xl: '6rem'
                            },
                            paddingLeft: {
                                xs: "10px",
                                sm: "9px",
                                md: "25px",
                                lg: "50px",
                                xl: "70px"
                            },

                            lineHeight: 1.2
                        }}
                    >
                        Welcome GET Mentor
                    </Typography>
                    <Box sx={{
                        maxWidth: "50%", textAlign: "center", mt: "5px"
                    }}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontFamily: `"Poppins", sans-serif !important`,
                                fontWeight: 600,
                                fontSize: {
                                    xs: "0.6rem",
                                    sm: "1.11rem",
                                    md: "1.6rem",
                                    lg: "1.7rem",
                                    xl: "2.2rem",
                                },
                                paddingLeft: { xs: "10px", sm: "9px", md: "31px", lg: "62px", xl: "100px" },
                                lineHeight: "1.3",
                                color: "rgb(43, 79, 96)",
                            }}
                        >
                            <span sx={{
                                fontSize: {
                                    xs: "0.6rem",
                                    sm: "1.11rem",
                                    md: "1.6rem",
                                    lg: "1.7rem",
                                    xl: "2.2rem",
                                }
                            }}>
                                Building A Global Community Where Past Study-Abroad Students Mentor Aspiring Ones,</span>
                            <Typography variant="span"
                                style={{
                                    color: "rgb(35, 168, 225)", fontSize: {
                                        xs: "0.8rem",
                                        sm: "1.11rem",
                                        md: "1.6rem",
                                        lg: "1rem",
                                        xl: "2rem",
                                    },
                                }}>
                                Offering Real Experiences Over Generic Advice. </Typography>
                        </Typography>
                        {/* <Box
                        sx={{
                            display: "flex",
                            gap: "10px",
                            marginTop: "15px",
                        }}
                    > */}
                        <Button
                            variant="outlined" onClick={() => navigate("/mentors")}
                            sx={{
                                // borderColor: "#2B4F60",
                                backgroundColor: "#2B4F60",
                                color: "#fff",
                                fontSize: "0.6rem",
                                fontWeight: "500",
                                mt: "5px",
                                "&:hover": {
                                    backgroundColor: "rgb(35, 168, 225)",
                                    color: "#fff",
                                },
                            }}
                        >
                            Find a mentor
                        </Button>
                    </Box>



                </motion.div>

            </Box>


            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: {
                        xs: "0px",
                        sm: "50px",
                    },
                    paddingLeft: '10px',
                }}
            >
                <Grid
                    container
                    spacing={2}
                    sx={{
                        marginTop: {
                            xs: "0px",
                            sm: '30px',
                        }, paddingTop: {
                            xs: "0px",
                            sm: '20px',
                        },
                        overflow: 'hidden'
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        md={5}
                        data-aos="fade-right"
                        sx={{
                            marginTop: {
                                xs: "0px",
                                sm: '50px',
                            },
                            paddingLeft: {
                                xs: '10px',
                                sm: '30px',
                                md: '35px',
                                lg: '50px',
                                xl: '50px',
                            },
                            color: 'rgb(43, 79, 96)',
                            display: 'grid',
                        }}
                    >
                        <Typography
                            variant="h3"
                            sx={{
                                fontSize: {
                                    xs: "1.2rem",
                                    sm: "2rem",
                                    md: "1.9rem",
                                    lg: "1.7rem",
                                    xl: "2.5rem",
                                },
                                fontWeight: 700,
                                lineHeight: 1,
                                marginBottom: "0px" // ✅ Removes extra bottom margin
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    display: "inline-block",
                                    fontSize: "inherit",
                                    fontWeight: "inherit",
                                    marginBottom: "0px",

                                }}
                            >
                                <AnimatedText data={phrases} />
                            </Box>
                        </Typography>

                        <Typography variant="h6" sx={{
                            fontSize: {
                                xs: "1.2rem",
                                sm: "1.5rem",
                                md: "1.3rem",
                                lg: "1.2rem",
                                xl: "1.6rem",
                            }, fontWeight: "400",
                            fontFamily: "Poppins, sans-serif", lineHeight: "1.5", paddingTop: "10px", textAlign: "center"
                        }}>College counseling shouldn't feel like a business deal. And learning everything alone? Overwhelming. That’s where your mentor steps in — not a teacher, not a counselor, but like the elder sibling you wish you had. Someone who's been there, done that, and is here to show you the way — real talk, real support, and zero jargon. </Typography>
                    </Grid>
                    {/* <Grid
                        size={{ xs: 12, md: 7 }}
                        container
                        direction="row"
                        spacing={8}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                            height: { xs: "300px", sm: "400px", md: "500px", lg: "500px", xl: "580px" },
                            marginTop: "30px",
                            paddingLeft: { xs: "60px", sm: "78px", md: "12px", lg: "98px", xl: "73px" },
                            paddingRight: { xs: "45px", sm: "30px", md: "2px", lg: "46px", xl: "30px" },
                            paddingBottom: { xs: "128px", sm: "130px", md: "191px", lg: "160px", xl: "58px" },
                            backgroundImage: `url(${homeback})`, // Fix background image
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            backgroundRepeat: "no-repeat",
                            objectFit: "fill"
                            // transform: "rotate(-90deg)",
                        }}
                    >
                        <Card
                            sx={{
                                transform: "rotate(45deg)",
                                border: "1px solid rgb(35, 168, 225)",
                                height: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                width: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",

                                overflow: "hidden", // ✅ Extra part hide karne ke liye
                                position: "relative",
                            }}
                        >
                            <div
                                style={{
                                    backgroundImage: `url(${home1})`,
                                    backgroundSize: "100% 100%", // ✅ Image scale kare taaki blank space na aaye
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    height: "100%",
                                    width: "100%",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    transform: "rotate(-45deg) scale(1.4)", // ✅ Rotate + Scale to fill space
                                }}
                            ></div>
                        </Card>


                        <Card
                            sx={{
                                transform: "rotate(45deg)", // ✅ Rotate the Card
                                border: "1px solid rgb(35, 168, 225)",
                                height: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                width: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                alignSelf: "flex-start",
                                overflow: "hidden", // ✅ Extra image hide
                                marginTop: "15px",
                                position: "relative",
                            }}
                        >
                            <div
                                style={{
                                    backgroundImage: `url(${home2})`,
                                    backgroundSize: "100% 100%", // ✅ Image scale kare taaki blank space na aaye
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    height: "100%",
                                    width: "100%",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    transform: "rotate(-45deg) scale(1.4)", // ✅ Rotate + Scale to fill space
                                }}
                            ></div>
                        </Card>
                        <Card
                            sx={{
                                transform: "rotate(45deg)",
                                border: "1px solid rgb(35, 168, 225)",
                                height: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                width: { xs: "60px", sm: "100px", md: "110px", lg: "130px", xl: "180px" },
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative",
                                alignSelf: "inherit", // Move to bottom
                            }}
                        >
                            <div
                                style={{
                                    backgroundImage: `url(${home3})`,
                                    backgroundSize: "100% 100%", // ✅ Image scale kare taaki blank space na aaye
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    height: "100%",
                                    width: "100%",
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    transform: "rotate(-45deg) scale(1.4)", // ✅ Rotate + Scale to fill space
                                }}
                            ></div>
                        </Card>
                    </Grid> */}
                    <Grid item xs={12} md={6} sx={{
                        display: "flex",  // 🔹 Flexbox apply kiya
                        justifyContent: "center", // 🔹 Center horizontally
                        alignItems: "center",  // 🔹 Center vertically
                        paddingLeft: {
                            xs: "0px"
                            , sm: "60px"
                        },
                        overflow: "hidden"
                    }}>
                        <Card data-aos="fade-left" sx={{
                            background: "#2B4F60", padding: {
                                xs: "0px"
                                , sm: "20px"
                            }, borderRadius: "12px", width: "80%"
                        }}>
                            <CardContent>
                                <Box
                                    ref={scrollRef}
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        overflowY: "auto",
                                        height: "300px",
                                        position: "relative",
                                        scrollbarWidth: "none",
                                        alignItems: "center", // 🔹 Center align cards
                                        "&::-webkit-scrollbar": { display: "none" },
                                    }}
                                >
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
                                        {studentfeed.concat(studentfeed).map((item, index) => (
                                            <Box key={index} sx={{ flex: "0 0 auto", marginBottom: "10px", display: "flex", justifyContent: "center", width: "100%" }}>
                                                <Card
                                                    sx={{
                                                        // border: "2px solid #0077CC",
                                                        padding: "10px",
                                                        borderRadius: "12px",
                                                        textAlign: "center",
                                                        cursor: "pointer",
                                                        transition: "transform 0.3s ease-in-out",
                                                        width: "80%", // 🔹 Card width 80% tak rakhi
                                                        // maxWidth: "350px", // 🔹 Max width set ki, taki bada na ho
                                                        height: "200px",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        backgroundColor: "#e0e0e0",
                                                        "&:hover": {
                                                            transform: "scale(1.05)",
                                                        },
                                                    }}
                                                >
                                                    <CardContent>
                                                      <Box
  sx={{
    display: { xs: "none", sm: "flex" }, // Hide on mobile (xs), show on sm+
    justifyContent: "center",
    mb: "10px",
  }}
>
  <Box
    sx={{
      width: "60px",
      height: "60px",
      border: "2px solid #0077CC",
      borderRadius: "50%",
      overflow: "hidden",
    }}
  >
    <img
      src={item?.image}
      alt={item?.name}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>
</Box>



                                                        <Typography variant="h6" fontWeight="bold" color="rgb(43, 79, 96)" fontFamily="Poppins, sans-serif">
                                                            {item.name}
                                                        </Typography>
                                                        <Box sx={{ marginTop: "10px" }}>
                                                            <Rating name="read-only" value={item.rate} readOnly />
                                                        </Box>
                                                        <Typography variant="body1" sx={{ whiteSpace: "pre-line", fontSize: "1rem", color: "rgb(43, 79, 96)", fontFamily: "Poppins, sans-serif" }}>
                                                            {item.feed}
                                                        </Typography>
                                                    </CardContent>
                                                </Card>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        sx={{
                            display: "flex",
                            justifyContent: "center", // ✅ Fix typo and center horizontally
                            alignItems: "center", // ✅ Center vertically
                            textAlign: "center", // ✅ Ensure text alignment
                            height: "100%", // ✅ Adjust if needed
                            paddingTop: "50px"
                        }}
                    >
                        <CardContent data-aos="fade-up"
                            sx={{
                                display: "flex",
                                flexDirection: "column", // ✅ Stack content vertically
                                alignItems: "center", // ✅ Center items inside
                                justifyContent: "center",
                                textAlign: "center",
                                width: "70%", // ✅ Control width
                            }}
                        >
                            <Typography
                                variant="h4"
                                sx={{
                                    padding: {
                                        xs: "0px",
                                        sm: "20px"
                                    },
                                    fontWeight: "400",
                                    fontFamily: "Poppins, sans-serif",
                                    fontStyle: "italic",
                                    lineHeight: "1.5",
                                    fontSize: {
                                        xs: "0.8rem",
                                        sm: "1.1rem",
                                        md: "1.2rem",
                                        lg: "1.4rem",
                                        xl: "1.8rem",
                                    }
                                }}
                            >
                                "A mentor is not someone who walks ahead of you to show you how they did it.
                                A mentor walks alongside you to show you what you can do"
                            </Typography>
                        </CardContent>
                    </Grid>

                </Grid>
            </Box>
            <Box >
                <Box sx={{ backgroundColor: "#bcdade", overflow: "hidden" }}>
                    <Typography variant="h4" data-aos="fade-right" sx={{
                        marginTop: "20px",
                        paddingTop: "20px",
                        marginBottom: "20px",
                        paddingBottom: "10px",
                        fontFamily: "Poppins, sans-serif", fontWeight: "500",
                        fontSize: {
                            xs: "2.2rem",
                            sm: "3rem",
                            md: "2.7rem",
                            lg: "3.1rem",
                            xl: "3.5rem",
                        }
                    }}>
                        <span style={{ color: "#2B4F60", fontWeight: "400" }}>What is </span>
                        <span style={{ color: "#23a8e1" }}>Get Mentors?</span>
                    </Typography>
                    <Box>
                        <Typography variant="body1" data-aos="fade-left" sx={{
                            mb: 3, pl: "50px", pr: "50px", fontSize: {
                                xs: "1.2rem",
                                sm: "1.5rem",
                                md: "1.3rem",
                                lg: "1.2rem",
                                xl: "1.6rem",
                            }, fontWeight: "400",
                            fontFamily: "Poppins, sans-serif", lineHeight: "1.5", textAlign: "center"
                        }}>
                            GET MENTORS is a student-to-student mentorship platform that empowers aspiring students to make informed decisions about studying abroad. Instead of relying on generic information from agents or forums, students can directly connect with real mentors who have successfully studied in their desired countries.
                        </Typography>

                    </Box>


                    <Box data-aos="zoom-in-up" sx={{ mb: 4, p: "10px", pb: "50px" }}>
                        <Grid container spacing={2}>
                            {highlights.map((text, idx) => (
                                <Grid item xs={12} sm={6} md={4} key={idx}>
                                    <Card
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            height: "50px", // Fixed height
                                            p: 2,
                                            borderRadius: "10px",
                                            fontFamily: "Poppins, sans-serif",
                                        }}
                                    >
                                        <CheckCircle sx={{ color: "#4caf50", mr: 1 }} />
                                        <Typography variant="body2" sx={{ textAlign: "left" }}>
                                            {text}
                                        </Typography>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>




                </Box>

                <Typography variant="h4" data-aos="fade-down" sx={{
                    marginTop: "40px",
                    paddingTop: "40px",
                    marginBottom: "20px",
                    paddingBottom: "10px",
                    fontFamily: "Poppins, sans-serif", fontWeight: "500",
                    fontSize: {
                        xs: "1.5rem",
                        sm: "2rem",
                        md: "1.8rem",
                        lg: "2.1rem",
                        xl: "2.4rem",
                    }
                }}>
                    <span style={{ color: "#2B4F60", fontWeight: "400" }}>Mentorship Domains</span>

                </Typography>
                <Grid container spacing={4} paddingLeft={6} paddingRight={6} data-aos="zoom-in" sx={{ paddingBottom: "50px" }}>
                    {domains.map((item, idx) => (
                        <Grid item xs={12} sm={6} md={4} key={idx} >
                            <Card
                                elevation={2}
                                sx={{
                                    backgroundColor: colors[idx], // only first 3 cards get color
                                    height: "100%",
                                }}
                            >
                                <CardContent sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    {item.icon}
                                    <Typography variant="body1">{item.title}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Grid spacing={6} sx={{
                marginTop: "65px",
                display: "flex",
                flexWrap: { xs: "wrap", md: "nowrap" },
                overflow: "hidden",
                flexDirection: { xs: "column", md: "row" }, justifyContent: "center",
                gap: { md: 4, xs: 0 }
            }}>

                <Grid xs={12} sm={12} lg={6} md={6} xl={6} size={{ md: 6 }} data-aos="fade-right" sx={{
                    background: "#b8e3e9",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    padding: "20px",
                    borderRadius: "15px",
                    // flexBasis: { xs: "100%", md: "50%" },
                    // width: { xs: "100%", md: "48%" },
                    overflow: "hidden",
                    paddingTop: "0px"
                }}>
                    <Box sx={{ display: "grid", justifyContent: "start", textAlign: "left", paddingTop: "0px" }}>
                        <Typography variant="h3" sx={{
                            color: "#2b4f60",
                            mb: "10px",
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: "500",
                            fontSize: {
                                xs: "2.2rem",
                                sm: "3rem",
                                md: "2.5rem",
                                lg: "2.1rem",
                                xl: "3.3rem",
                            },

                        }}>
                            Why Mentoring
                        </Typography>
                        <Typography variant="body2" sx={{
                            mb: "20px", fontFamily: "Poppins, sans-serif", fontWeight: "300", fontSize: {
                                xs: "1.1rem",
                                sm: "1.2rem",
                                md: "1rem",
                                lg: "1rem",
                                xl: "1.5rem",
                            }
                        }}>
                            Mentorship is more than just guidance—it’s a powerful tool that shapes futures. Having a mentor can make a significant impact on personal, academic, and professional growth.
                        </Typography>
                        <Typography variant="body2" sx={{
                            mt: "16px", fontFamily: "Poppins, sans-serif", fontWeight: "400", fontSize: {
                                xs: "1.3rem",
                                sm: "1.4rem",
                                md: "1rem",
                                lg: "0.9rem",
                                xl: "1.4rem",
                            }
                        }}>
                            Studies show that young people with mentors feel more emotionally supported, leading to improved mental well-being.
                        </Typography>
                    </Box>
                    <CustomProgress variant="determinate" value={65} trackColor="White" barColor="#ff7675" sx={{ width: "100%", marginTop: 2 }} />
                    <Typography sx={{
                        mt: "15px", fontFamily: "Poppins, sans-serif", fontWeight: "400", textAlign: "left", fontSize: {
                            xs: "1.3rem",
                            sm: "1.4rem",
                            md: "1rem",
                            lg: "0.9rem",
                            xl: "1.4rem",
                        }
                    }} variant="body2">
                        Students with mentors receive better guidance, perform well in school, and stay motivated to achieve their goals.
                    </Typography>
                    <CustomProgress variant="determinate" value={40} trackColor="White" barColor="#6ab7f5" sx={{ width: "100%", marginTop: 2 }} />
                    <Typography sx={{
                        mt: "15px", fontFamily: "Poppins, sans-serif", fontWeight: "400", textAlign: "left", fontSize: {
                            xs: "1.3rem",
                            sm: "1.4rem",
                            md: "1rem",
                            lg: "0.9rem",
                            xl: "1.4rem",
                        }
                    }} variant="body2">
                        Mentorship provides valuable career insights, networking opportunities, and skill development for a brighter future.
                    </Typography>
                    <CustomProgress variant="determinate" value={80} trackColor="White" barColor="#81c784" sx={{ width: "100%", marginTop: 2, marginBottom: 5 }} />
                </Grid>

                <Grid item xs={12} sm={12} lg={6} md={6} xl={6} size={{ md: 6 }} data-aos="fade-left"
                    sx={{
                        background: "#93b1b5",
                        display: "flex",
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        padding: "20px",
                        textAlign: "left",
                        flexGrow: 1,
                        borderRadius: "15px",
                        overflow: "hidden"
                    }}>
                    <Box sx={{ display: "grid", justifyContent: "start", textAlign: "left" }}>
                        <Typography variant="h3" sx={{
                            color: "#2B4F60",
                            textAlign: "center",
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: "500",
                            fontSize: {
                                xs: "1.2rem",
                                sm: "3rem",
                                md: "2.5rem",
                                lg: "2.1rem",
                                xl: "3.3rem",
                            }
                        }}>
                            WHY NOW?
                        </Typography>
                        <Typography variant="body2" sx={{
                            mt: "15px",
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: "300",
                            textAlign: "center",
                            color: "#fff",
                            fontSize: {
                                xs: "1.2rem",
                                sm: "1.2rem",
                                md: "1.3rem",
                                lg: "1rem",
                                xl: "1.5rem",
                            }
                        }}>
                            Universities are more competitive, so making your application stand out is crucial. Education costs are rising, emphasizing the need for scholarships and financial planning. Visa and immigration policies are evolving, requiring real-time insights. The global job market is changing—start networking early to gain an advantage in your career.
                        </Typography>
                        <Stack alignItems="center" mt={4}>
                            <CardMedia
                                component="img"
                                image={whynow}
                                alt="Mentoring"
                                sx={{
                                    borderRadius: "50%",
                                    width: {
                                        xs: "100%",
                                        sm: "100%",
                                        md: "100%",
                                        lg: "60%",
                                        xl: "60%",
                                    },
                                    height: "100%",
                                }}
                            />
                        </Stack>
                    </Box>
                </Grid>
            </Grid>

            <Typography
                variant="h2"
                data-aos="fade-up"
                sx={{
                    marginTop: "50px",
                    paddingTop: "50px",
                    marginBottom: "50px",
                    paddingBottom: "50px",
                    fontFamily: "Poppins, sans-serif", fontWeight: "500",
                    fontSize: {
                        xs: "2.2rem",
                        sm: "3rem",
                        md: "2.7rem",
                        lg: "3.1rem",
                        xl: "3.5rem",
                    }
                }}
            >
                <span style={{ color: "#2B4F60", fontWeight: "400" }}>Empowering Your Journey </span>
                <span style={{ color: "#23a8e1" }}>with Expert Mentorship</span>
            </Typography>
            <Box data-aos="zoom-in"
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" }, // ✅ Mobile pe column, desktop pe row
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "20px", // ✅ Cards ke beech gap maintain karega
                    padding: "20px",
                }}
            >
                {cardsData.map((card, index) => (
                    <FlipCard key={index} card={card} />
                ))}
            </Box>

            {/* <Stack >
                <Typography
                    variant="h1"
                    data-aos="fade-up"
                    sx={{
                        marginTop: "50px",
                        paddingTop: "50px",
                        marginBottom: "50px",
                        paddingBottom: "50px",
                        fontFamily: "Poppins, sans-serif",
                        fontSize: {
                            xs: "2.2rem",
                            sm: "3rem",
                            md: "2.7rem",
                            lg: "3.1rem",
                            xl: "3.5rem",
                        }
                    }}
                >
                    <span style={{ color: "#2B4F60", fontWeight: "400" }}>Our Top</span>
                    <span style={{ color: "#23a8e1" }}> Mentors</span>
                </Typography>
            </Stack> */}
            {/* <Grid container spacing={6} sx={{ display: "flex", justifyContent: "center", overflow: "hidden" }} >
                {MentosData.map((item, index) => (
                    <Grid item key={index} xs={12} sm={6} lg={4} data-aos="zoom-in" sx={{ display: "flex" }}>
                        <Card
                            sx={{
                                padding: 2,
                                textAlign: "center",
                                background: `#${item.color}`,
                                borderRadius: "15px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",  // ✅ Equal width cards
                                height: "100%", // ✅ Equal height cards
                                flexGrow: 1,    // ✅ Sab cards equal size le
                            }}
                            onClick={() => handleOpenDrawer(item)}
                        >
                            <CardMedia
                                component="img"
                                image={item?.image}
                                alt={item.name}
                                sx={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "15px",
                                    display: "block",
                                    margin: "0 auto",
                                }}
                            />

                            <CardContent
                                sx={{
                                    flexGrow: 1, // ✅ Equal height maintain karega
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                <Stack sx={{ alignItems: "center" }} spacing={1}>
                                    <Rating name="read-only" value={item.rate} readOnly />
                                    <Typography variant="h5" sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        fontWeight: "400",
                                        fontSize: { xs: "2.2rem", sm: "1.7rem", md: "1.9rem", lg: "1.5rem", xl: "2rem" }
                                    }}>
                                        {item.name}
                                    </Typography>
                                    <Typography variant="body1" sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        fontWeight: "500",
                                        fontSize: { xs: "1.5rem", sm: "1rem", md: "1.2rem", lg: "1.2rem", xl: "1.5rem" }
                                    }} color="text.secondary">
                                        {item.exp}
                                    </Typography>
                                    <Typography variant="body2" sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        fontWeight: "300",
                                        fontSize: { xs: "1.7rem", sm: "1.2rem", md: "1.5rem", lg: "1.4rem", xl: "1.2rem" }
                                    }}>
                                        {item.Desc}
                                    </Typography>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid> */}


            <div className="marquee-container" style={{ marginTop: "80px" }}>
                <div className="marquee">
                    <div className="marquee-content">
                        {images.map((src, index) => (
                            <img key={index} src={src} alt={`Image ${index + 1}`} className="marquee-image" />
                        ))}
                        {images.map((src, index) => (
                            <img key={`dup-${index}`} src={src} alt={`Duplicate ${index + 1}`} className="marquee-image" />
                        ))}
                    </div>
                </div>
            </div>
            <Box sx={{ marginTop: "50px" }}>
                <Typography data-aos="fade-up" variant="h1"
                    sx={{
                        pt: "50px",
                        mb: "50px", fontFamily: "Poppins, sans-serif", fontWeight: "400", fontSize: {
                            xs: "2.2rem",
                            sm: "3rem",
                            md: "2.7rem",
                            lg: "3.1rem",
                            xl: "3.5rem",
                        }
                    }}>
                    <span style={{ color: "#2B4F60" }}>Bene</span>
                    <span style={{ color: "#23a8e1" }}>fits</span>
                </Typography>

                <Grid container spacing={4} alignItems="center" sx={{ background: "#bcdade", padding: "35px", overflow: "hidden" }}>

                    <Grid
                        item data-aos="fade-up-right"
                        xs={12}
                        md={4}
                        sx={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                            alignItems: "center" // Centers vertically
                        }}
                    >
                        <CardMedia
                            component="img"
                            image={home5}
                            sx={{
                                width: "45%",
                                borderRadius: 3
                            }}
                        />
                    </Grid>


                    <Grid item data-aos="fade-up-left" xs={12} md={8} sx={{ textAlign: "left" }}>
                        <Typography variant="h4" fontWeight="bold">
                            At your fingertips: a dedicated career coach
                        </Typography>
                        <Typography variant="body1" color="textSecondary" mt={2}>
                            Want to start a new dream career? Successfully build your startup? Itching to learn high-demand skills? Work
                            smart with an online mentor by your side to offer expert advice and guidance to match your zeal. Become
                            unstoppable using MentorCruise.
                        </Typography>

                        <Grid container spacing={2} mt={3}>
                            {benefits.map((benefit, index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <CheckCircleIcon color="success" fontSize="small" />
                                        <Typography variant="body1">{benefit}</Typography>
                                    </Stack>
                                </Grid>
                            ))}
                        </Grid>

                        <Button onClick={() => navigate("/mentors")} variant="contained" color="success" size="large" sx={{ mt: 3 }}>
                            Find a mentor →
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Typography
                variant="h1" data-aos="fade-up"
                sx={{
                    marginTop: "50px",
                    // marginBottom: "50px",
                    fontFamily: "Poppins, sans-serif",
                    fontSize: {
                        xs: "2.2rem",
                        sm: "3rem",
                        md: "2.7rem",
                        lg: "3rem",
                        xl: "3.5rem",
                    }
                }}
            >
                <span style={{ color: "#2B4F60", fontWeight: "400" }}>Burning</span>
                <span style={{ color: "#23a8e1" }}> Questions</span>
            </Typography>
            <Grid container spacing={6} sx={{ display: "flex", alignItems: "stretch", padding: "30px", mb: "50px", overflow: "hidden" }}>

                <Grid item data-aos="fade-right" md={6} lg={8} sx={{ height: "100%", display: "block", flexDirection: "column", justifyContent: "flex-end" }}>
                    <Card sx={{ height: "100%", border: "1px solid #23a8e1", borderRadius: "10px", boxShadow: "0px 4px 30px #2B4F60", marginLeft: "50px" }}>
                        <CardContent sx={{ textAlign: "left", height: "100%", display: "flex", flexDirection: "column", fontFamily: "Poppins, sans-serif" }}>
                            <CustomAccordion
                                summary="How do I choose the right university and course?"
                                details="Our mentors help you align your goals, budget, and preferences with the best-fit options."
                                useFade={true}
                            />
                            <CustomAccordion
                                summary="What if my visa gets rejected?"
                                details="Talk to mentors who have experienced this. Learn from their strategies to reapply confidently."
                                useFade={false}
                            />
                            <CustomAccordion
                                summary="Can I work while studying abroad?"
                                details="Yes! Get clarity on part-time work rights, finding jobs, and balancing studies."
                                useFade={true}
                            />
                            <CustomAccordion
                                summary="How do I apply for scholarships?"
                                details="Mentors share hidden tips and strategies for maximizing scholarship chances."
                                useFade={true}
                            />
                            <CustomAccordion
                                summary="What is the cost of living in my chosen country?"
                                details="Mentors break down real monthly expenses including rent, groceries, and more."
                                useFade={true}
                            />
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item data-aos="fade-left" md={6} lg={4} sx={{ height: "100%", display: "flex", justifyContent: "start" }}>
                    <CardMedia component="img" image={burning} sx={{
                        width: {
                            xs: "100%",
                            sm: "100%",
                            md: "100%",
                            lg: "100%",
                            xl: "70%",
                        }, background: "grey", borderRadius: "30px"
                    }} />
                </Grid>
            </Grid>



            <RightSwipeableDrawer open={openDrawer} setOpen={setOpenDrawer} data={selectedItem} />
        </>
    )
};

export default Home;